import React, { ChangeEvent, FormEvent, useRef, useState } from 'react';
import Layout from '../components/Layout';
import emailjs from 'emailjs-com';
import { storage } from '../firebaseConfig';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from "react-google-recaptcha";
import '../App.css';

const OrderNow = () => {
  const recaptcha = useRef<typeof ReCAPTCHA | null>(null);
      const [formData, setFormData] = useState({
name: '',
    email: '',
    phone: '',
    subject: '',
    orderDescription: '',
    deadline: '',
    file: null as File | null
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    if (name === 'phone') {
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      setFormData({
        ...formData,
        [name]: numericValue
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFormData({
        ...formData,
        file: e.target.files[0]
      });
    }
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { name, email, phone, subject, orderDescription, deadline, file } = formData;
    let hasError = false;
    let fileURL = 'No file attached';
    if (file) {
      const fileRef = ref(storage, `enquiries/${file.name}`);
      await uploadBytes(fileRef, file);
      fileURL = await getDownloadURL(fileRef);
    }

    const recaptchaToken = recaptcha.current?.getValue();
    if (!recaptchaToken) {
      toast.error('Please complete the reCAPTCHA before submitting');
      hasError = true;
  }

  if (phone.length !== 10) {
      toast.error('Phone number must be of 10 digits');
      hasError = true;
  }

  if (hasError) {
      return; 
  }

    const templateParams = {
      name,
      email,
      phone,
      subject,
      orderDescription,
      deadline,
      file: fileURL
    };
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || ''
    const templateId = "template_huid60r"
    const userId = process.env.REACT_APP_EMAILJS_USER_ID || ''
    emailjs.init(userId);
    emailjs.send(serviceId, templateId, templateParams, userId)
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        console.log("jchje:", userId);
        toast.success('Enquiry sent successfully!');
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          orderDescription: '',
          deadline: '',
          file: null
        });
        recaptcha.current?.reset(); 
      }, (err) => {
        console.log('FAILED...', err);
        toast.error('Failed to send enquiry. Please try again.');
      });
  };

  return (
    <Layout>
      <div className="bubbles">
      <div className="bubble"></div>
    <div className="bubble"></div>
    <div className="bubble"></div>
    <div className="bubble"></div>
    <div className="bubble"></div>
    <div className="bubble"></div>
    <div className="bubble"></div>
    <div className="bubble"></div>
    <div className="bubble"></div>
    <div className="bubble"></div>
    </div>
    <div className="textBuddy">
<p className="text" data-text="fill the form below">
fill the form below
</p>
</div>
    <div style={{position: 'relative', zIndex: '1000'}}>
      <form onSubmit={handleSubmit} className="max-w-lg mx-auto p-4 border rounded-lg shadow-md bg-white">
        <h2 className="text-2xl font-bold mb-4 text-center text-orange-500">Order Request Form</h2>
        <div className="flex justify-center">
        </div>
        <div className="mb-4">
          <input
            type="name"
            id="name"
            name="name"
            placeholder="Fullname"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-2 border rounded-lg"
            required
          />
        </div>
        <div className="mb-4">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            className="w-full p-2 border rounded-lg"
            required
          />
        </div>
        <div className="mb-4 flex">
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder="Phone no."
            value={formData.phone}
            onChange={handleChange}
            className="w-full p-2 border rounded-lg"
            required
          />
        </div>
        <div className="mb-4">
          <input
            type="subject"
            id="subject"
            name="subject"
            placeholder="Enter your subject"
            value={formData.subject}
            onChange={handleChange}
            className="w-full p-2 border rounded-lg"
            required
          />
        </div>
        <label htmlFor="deadline" className="text-gray-500 ml-[10px]">
    Select deadline
  </label>
        <div className="mb-4">
          <input
            type="date"
            id="deadline"
            name="deadline"
            value={formData.deadline}
            onChange={handleChange}
            className="w-full p-2 border rounded-lg"
            required
          />
        </div>
        <div className="mb-4">
          <textarea
            id="orderDescription"
            name="orderDescription"
            placeholder="Order Description (Write/Attach)"
            value={formData.orderDescription}
            onChange={handleChange}
            className="w-full min-h-[100px] p-2 border rounded-lg"
            required
          />
          </div>
          <div className="mb-4">
          <input
            type="file"
            id="file"
            name="file"
            onChange={handleFileChange}
            className=""
          />
        </div>
        <div className="mb-4">
        <ReCAPTCHA ref={recaptcha} sitekey="6LcllxYqAAAAAPBcE2iXml2ed1id669xn9KWCf7U" />
        </div>
        <button 
          type="submit"
          className="w-full p-2 bg-orange-500 text-white font-bold rounded-lg hover:bg-orange-700"
        >
          Submit
        </button>
      </form>
      <ToastContainer />
    </div>
    </Layout>
  );
}

export default OrderNow;
